import * as Excel from '@grapecity/spread-excelio';
import * as GC from '@grapecity/spread-sheets';
import * as fileSaver from 'file-saver';

const excelIO = new Excel.IO();
/**
 * Uses a Web Worker to export the data to Excel in a non-blocking way (asynchronously).
 * More info at:
 * https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers
 */
// export const workerExport = async (workbook: GC.Spread.Sheets.Workbook) => {
//   const jsFileUrl = `assets/web-workers/export.web-worker.js`;
//   const worker = new Worker(jsFileUrl);

//   // ------ WORKER EVENTS ------
//   // Messages
//   worker.onmessage = function(event) {
//     // result.textContent = event.data;
//     console.log('Message received from worker', event);
//   };

//   //   // Error
//   worker.onerror = function(error) {
//     console.log(`[Worker] - error happend inside the worker`, error);
//   };
//   // ---------------------------

//   // TODO: Destroy the worker once the export has finished
//   // TODO: Worker export
// };

function suspendAll(item: GC.Spread.Sheets.Workbook | GC.Spread.Sheets.Worksheet) {
  item.suspendPaint();
  item.suspendCalcService(true);
  item.suspendEvent();
}

function resumeAll(item: GC.Spread.Sheets.Workbook | GC.Spread.Sheets.Worksheet) {
  item.resumePaint();
  item.resumeCalcService(true);
  item.resumeEvent();
}

function setSpreadOptions(spread: GC.Spread.Sheets.Workbook) {
  spread.options.tabStripVisible = true;
}

function createExportWorkbook() {
  const spread: GC.Spread.Sheets.Workbook = new GC.Spread.Sheets.Workbook();
  setSpreadOptions(spread);

  return spread;
}

function removeSheetFrom(spread: GC.Spread.Sheets.Workbook, sheetName: string) {
  if (spread && spread.getSheetIndex(sheetName) > -1) {
    const sheetIndex = spread.getSheetIndex(sheetName);
    spread.removeSheet(sheetIndex);
  }
}

function addSheetTo(
  exportWorkbook: GC.Spread.Sheets.Workbook,
  sheetName: string,
  sheetToExport: GC.Spread.Sheets.Worksheet
): GC.Spread.Sheets.Worksheet {
  if (exportWorkbook.getSheetFromName(sheetName) !== null) {
    exportWorkbook.removeSheet(exportWorkbook.getSheetIndex(sheetName));
  }
  exportWorkbook.addSheet(exportWorkbook.getSheetCount() + 1, sheetToExport);

  return exportWorkbook.getSheetFromName(sheetName);
}

function buildSheetForExport(sheetName: string, exportWorkbook: GC.Spread.Sheets.Workbook, origWorkbook: GC.Spread.Sheets.Workbook) {
  const origSheetJson = origWorkbook.getSheetFromName(sheetName);
  const sheetToExport = new GC.Spread.Sheets.Worksheet(sheetName); // Clone the object to don't affect the original

  // Import data in It
  const jsonSrcData = origSheetJson.toJSON();
  sheetToExport.fromJSON(jsonSrcData);

  // Add the new Sheet to the workbook for export
  return addSheetTo(exportWorkbook, sheetName, sheetToExport);
}

function getExcelExportFileName(refDate: Date): string {
  const monthVal = refDate.getMonth() + 1;

  // If any of them is 1-digit number, add a 0 at the start
  const month: string = `${monthVal}`.length === 1 ? `0${monthVal}` : `${monthVal}`;
  const year: string = `${refDate.getFullYear()}`.length === 1 ? `0${refDate.getFullYear()}` : `${refDate.getFullYear()}`;
  const day: string = `${refDate.getDate()}`.length === 1 ? `0${refDate.getDate()}` : `${refDate.getDate()}`;

  const fileNameDate = [month, day, year].join('.');

  // File name
  const fileName = `Calibration_Summary_${fileNameDate}.xlsx`;

  return fileName;
}

function buildExportWorkbook(origWorkbook: GC.Spread.Sheets.Workbook): GC.Spread.Sheets.Workbook {
  // ==== Create the sheet Sheets for Export ====
  const exportWorkbook: GC.Spread.Sheets.Workbook = createExportWorkbook();

  // Suspend SpreadJS Events
  suspendAll(exportWorkbook);

  // Build Sheets for Export
  {
    // Remove the default sheet
    removeSheetFrom(exportWorkbook, 'Sheet1');
    // Build the sheets to be exported
    origWorkbook.sheets.forEach(sheet => buildSheetForExport(sheet.name(), exportWorkbook, origWorkbook));
  }

  // Resume SpreadJS Events
  resumeAll(exportWorkbook);

  return exportWorkbook;
}

function nonWorkerExport(origWorkbook: GC.Spread.Sheets.Workbook) {
  // console.log('Posting message to worker', { srcWorkbook });
  // worker.postMessage(JSON.stringify(srcWorkbook));

  // ==== Export to EXCEL ====
  // Convert everything to JSON for export
  const exportFileDate = new Date(new Date().toUTCString()).toJSON();
  const fileName: string = getExcelExportFileName(new Date(exportFileDate));

  const exportWorkbook: GC.Spread.Sheets.Workbook = buildExportWorkbook(origWorkbook);

  for (let i = 0; i < exportWorkbook.getSheetCount(); i++) {
    exportWorkbook.getSheet(i).options.isProtected = false;
  }
  // const excelIO = new Excel.IO();
  // const excelIO = new GC.Spread.Excel.IO();

  const jsonDataToExport: string = JSON.stringify(exportWorkbook.toJSON());
  // console.log(excelIO);
  excelIO.save(
    // Data to export
    jsonDataToExport,
    // success callback
    blob => {
      fileSaver.saveAs(blob, fileName);

      // Destroy It once has finished
      // exportWorkbook.destroy();
    },
    // error callback
    err => {
      console.warn(`Error saving file "${fileName}"`, err);
    }
  );
}

export const exportWorkbookToExcel = async (workbook: GC.Spread.Sheets.Workbook) => {
  // Web Workers Feature detection:
  // if (!window || !window.hasOwnProperty('Worker')) {
  //   return nonWorkerExport(workbook);
  // } else {
  //   return workerExport(workbook);
  // }

  return nonWorkerExport(workbook);
};
